// extracted by mini-css-extract-plugin
export const content_box = "ContentBox-module--content_box--2PbAT";
export const content_box__header = "ContentBox-module--content_box__header--1B7Mq";
export const content_box__content = "ContentBox-module--content_box__content--ppQZi";